module.exports = __webpack_public_path__ + "static/media/John Anderson - 1980.7de663ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/John Anderson - 1980.jpg
// module id = 515
// module chunks = 0